export const ACTIONS = {
  SET_INTERACTION_COMPONENT: 'interactionComponent',
  SET_INTERACTION_FUNCTION_RESPONSE: 'interactionFunctionResponse',
  SET_INTERACTION_INFO: 'setInteractionInfo',
  SET_CHANNELS_INTEGRATIONS: 'setChannelsIntegrations',
  SET_ADS_DETAILS: 'setAdsDetails'
}
